import { sectionRenderer } from '@theme/section-renderer';

// Liquid omits unavailable cards immediately. The native availability filter also
// fills pages correctly across the entire catalog, including direct landing URLs.
async function initializeInStockCatalog() {
  const url = new URL(location.href);
  if (url.searchParams.get('filter.v.availability') === '1') return;
  const results = document.querySelector('results-list[section-id]');
  const sectionId = results?.getAttribute('section-id');
  if (!sectionId || Shopify.designMode) return;
  url.searchParams.set('filter.v.availability', '1');
  results.setAttribute('aria-busy', 'true');
  try {
    await sectionRenderer.renderSection(sectionId, { url: new URL(url), cache: false, injectStylesheet: true });
    history.replaceState(history.state, '', url);
  } catch (error) {
    // Existing server-rendered in-stock cards and native links remain usable.
    console.warn('Could not refresh the in-stock catalog.', error);
  } finally {
    document.querySelector('results-list[section-id]')?.removeAttribute('aria-busy');
  }
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeInStockCatalog, { once: true });
} else {
  initializeInStockCatalog();
}

// Native navigation carries the filter before the first server response.
document.addEventListener('click', (event) => {
  const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
  if (!link) return;
  const url = new URL(link.href, location.origin);
  if (url.origin === location.origin && /\/collections\/[^/]+\/?$/.test(url.pathname)) {
    url.searchParams.set('filter.v.availability', '1');
    link.href = url.href;
  }
}, { capture: true });
